/* eslint-disable no-nested-ternary */
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Button, IconButton, InputAdornment, useMediaQuery, useTheme } from '@material-ui/core';
import styled from 'styled-components';
import querystring from 'query-string';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { MIX_PANEL_TRACK, some } from '../../../../constants';
import FormControlAutoComplete from '../../../common/components/FormControlAutoComplete';
import FormControlTextField from '../../../common/components/FormControlTextField';
import { Row, Col } from '../../../common/components/elements';
import { RestaurantListFilter, defaultRestaurantListFilter } from '../../utils';
import { PRIMARY } from '../../../../configs/colors';
// import { ReactComponent as IconCalender } from '../../../../svg/ic_calendar.svg';
import { ReactComponent as IconRestaurant } from '../../../../svg/icon_restaurant.svg';
import { ReactComponent as IconBeverage } from '../../../../svg/icon_beverage.svg';
import { ReactComponent as IconSearch } from '../../../../svg/ic_search.svg';
import { ReactComponent as IconDestinationPinPink } from '../../../../svg/icon_destination_pin_pink.svg';
import { Mixpanel } from '../../../../configs/mixpanel';

interface Props {
  locations: some[];
  cuisines: some[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchBox: {
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%,0)',
      top: '-35px',
      zIndex: 11,
      background: '#fff',
      padding: '15px 15px',
      borderRadius: '8px',
      width: '100%',
      maxWidth: '900px',
      // eslint-disable-next-line no-useless-computed-key
      ['@media (max-width:767px)']: {
        position: 'static',
        transform: 'translate(0)',
        display: 'block',
      },
    },
  }),
);

const SearchWrap = styled.div`
  position: relative;
  margin-bottom: 10px;
`;
const HomeSearch: React.FC<Props> = (props) => {
  const { locations, cuisines } = props;
  const classes = useStyles();
  const history = useHistory();
  const intl = useIntl();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesLarge = useMediaQuery(theme.breakpoints.down(700));
  const matchesIpad = useMediaQuery(theme.breakpoints.down(992));
  const [filter, setFilter] = React.useState<RestaurantListFilter>(defaultRestaurantListFilter);
  const handleSearch = React.useCallback(() => {
    Mixpanel.track(MIX_PANEL_TRACK.SEARCH_CLICK, '');
    const location: any = sessionStorage.getItem('query-home')
      ? JSON.parse(sessionStorage.getItem('query-home') || '')
      : '';
    history.push({
      pathname: '/category',
      search: `?${querystring.stringify({
        ...filter,
        latitude: location.lat ? parseFloat(location.lat) : filter.latitude,
        longitude: location.long ? parseFloat(location.long) : filter.longitude,
      })}`,
    });
  }, [history, filter]);

  const { term } = filter;
  return (
    <SearchWrap>
      <Row className={classes.searchBox}>
        <Col style={{ marginRight: matchesLarge ? 0 : matchesIpad ? 10 : 0 }}>
          <FormControlTextField
            placeholder={intl.formatMessage({ id: 'restaurantName' })}
            style={
              !matches ? { marginRight: 30, fontSize: 16 } : { marginBottom: 10, fontSize: 16 }
            }
            value={term}
            onChange={(e) => setFilter({ ...filter, term: e.target.value })}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 8 }}>
                <IconButton size="small" edge="start">
                  <IconRestaurant />
                </IconButton>
              </InputAdornment>
            }
          />
        </Col>
        <Col style={{ marginRight: matchesLarge ? 0 : matchesIpad ? 10 : 0 }}>
          <FormControlAutoComplete
            placeholder={intl.formatMessage({ id: 'allCuisines' })}
            options={cuisines}
            formControlStyle={!matches ? { marginRight: 30 } : { marginBottom: 10, marginRight: 0 }}
            multiple
            getOptionLabel={(item) => item.value}
            onChange={(e: any, value: any): void => {
              value?.length &&
                setFilter({
                  ...filter,
                  cuisine_ids: value.map((cuisine: any) => cuisine.id).toString(),
                });
            }}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 8 }}>
                <IconButton size="small" edge="start">
                  <IconBeverage style={{ width: '17px' }} />
                </IconButton>
              </InputAdornment>
            }
          />
        </Col>
        <Col style={{ marginRight: matchesLarge ? 0 : matchesIpad ? 10 : 0 }}>
          <FormControlAutoComplete
            placeholder={intl.formatMessage({ id: 'allLocation' })}
            options={locations}
            formControlStyle={!matches ? { marginRight: 30 } : { marginBottom: 10, marginRight: 0 }}
            getOptionLabel={(item) => item.name}
            onChange={(e: any, value: any): void => {
              value?.code && setFilter({ ...filter, city_code: value.code, city_id: value.id });
            }}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 8 }}>
                <IconButton size="small" edge="start">
                  <IconDestinationPinPink style={{ width: '17px' }} />
                </IconButton>
              </InputAdornment>
            }
          />
        </Col>
        <Col>
          <Button
            style={{
              background: PRIMARY,
              fontSize: 16,
              padding: '0 10px',
              fontWeight: 400,
              color: '#fff',
              height: 40,
              marginBottom: matchesIpad ? 10 : 0,
            }}
            onClick={() => handleSearch()}
          >
            {matchesIpad ? (
              <IconSearch style={{ width: 24, height: 24 }} />
            ) : (
              intl.formatMessage({ id: 'search' })
            )}
          </Button>
        </Col>
      </Row>
    </SearchWrap>
  );
};

export default HomeSearch;
